import BaseViewModel from '@src/slide/infrastructure/module/independent/view-service-define/base/base-view-model';
import { IAnimationEditorProps, IAnimationEditorState } from '@src/slide/application/service/animation-editor-manager/core/interface';
import { IObservableArray } from 'mobx';
import { IAnimListItem } from '@src/slide/domain/ui-model/element-modeles/Interface/anim-model.interface';

export default class AnimationEditorModel extends BaseViewModel<IAnimationEditorProps>
    implements IAnimationEditorState {
    public animList: IObservableArray<IAnimListItem>;
    public hasAnimSupportElement: boolean;
    public unfoldItemKey: string|null;
    public initModel(props: IAnimationEditorProps, initObj?: Partial<this>): void {
        this.unfoldItemKey = null;
        if (initObj?.hasAnimSupportElement) {
            this.hasAnimSupportElement = initObj.hasAnimSupportElement;
        }
        if (initObj?.animList) {
            this.animList = initObj.animList;
        }
    }
}
